import { IncomingPostbackStepLogTable } from "components/Tables/IncomingPostbackStepLogTable/IncomingPostbackStepLogTable";
import { TenantPage } from "components/UI/TenantPage/TenantPage";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getLogHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback-steps/"
)({
    component: IncomingPostbackStepLogPage,
    staticData: {
        permissions: [PermissionEnum.StepLogIncomingPostbacksView],
        showInSideMenu: false,
        label: "pages.log.tracking.from-steps.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.tracking.from-steps.title"),
        };
    },
});

function IncomingPostbackStepLogPage() {
    return (
        <TenantPage headerNavigationItems={getLogHeaderItems}>
            <IncomingPostbackStepLogTable />
        </TenantPage>
    );
}
